import styled from "styled-components";

export const InputUI = styled("input")`
  width: 384px;
  padding: 21px 33px;
  border: 0;
  height: 63px;
  background: #FFFFFF;
  border-radius: 20px;
  font-family: inherit;
  &::placeholder {
    font-family: inherit;
    color: #9CA1BA;
    font-size: 18px;
    font-weight: 400;
  }
`;
